(function () {
  // Prevent double initialization
  if (window.__collectionFiltersInitialized) return;
  window.__collectionFiltersInitialized = true;

  /**
   * Attach event delegation for collection filter buttons so that
   * we can swap the product grid via fetch instead of a full page
   * reload.
   */
  function initCollectionFilters() {
    const wrapper = document.querySelector('.collection-filter-wrapper');
    if (!wrapper) return;

    wrapper.addEventListener('click', (e) => {
      const btn = e.target.closest('.collection-filter__btn');
      if (!btn) return;

      // Only handle left-click without modifier keys to preserve default behaviour otherwise
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      e.preventDefault();
      handleFilterClick(btn, wrapper);
    });

    // Handle browser navigation (back / forward)
    window.addEventListener('popstate', () => {
      const currentPath = window.location.pathname.replace(/\/$/, ''); // strip trailing slash
      const targetBtn = wrapper.querySelector(
        `.collection-filter__btn[href='${currentPath}'], .collection-filter__btn[href='${currentPath}/']`
      );
      if (targetBtn) {
        handleFilterClick(targetBtn, wrapper, false);
      } else {
        // Fall back to hard reload if the handle is unknown
        window.location.reload();
      }
    });
  }

  /**
   * Fetch the section HTML for the desired collection and replace the product grid.
   * @param {HTMLAnchorElement} btn
   * @param {HTMLElement} wrapper
   * @param {Boolean} pushState
   */
  function handleFilterClick(btn, wrapper, pushState = true) {
    const href = btn.getAttribute('href');
    if (!href) return;

    const sectionId = wrapper.dataset.sectionId || document.querySelector('#product-grid')?.dataset?.id;
    if (!sectionId) {
      window.location.href = href;
      return;
    }

    const requestUrl = `${href}?section_id=${sectionId}`;

    // Show loading state
    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) gridContainer.classList.add('loading');

    fetch(requestUrl)
      .then((r) => {
        if (!r.ok) {
          throw new Error(`Request failed with status ${r.status}`);
        }
        return r.text();
      })
      .then((htmlString) => {
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        const newGridContainer = doc.getElementById('ProductGridContainer');
        // If the target section isn't present on the destination page, fallback to hard navigation
        if (!newGridContainer || !gridContainer) {
          window.location.href = href;
          return;
        }
        gridContainer.innerHTML = newGridContainer.innerHTML;
        gridContainer.classList.remove('loading');

        // Update active state classes
        wrapper.querySelectorAll('.collection-filter__btn').forEach((el) => {
          el.classList.remove('is-active', 'active');
        });
        btn.classList.add('is-active', 'active');

        // Push browser history state so back button works
        if (pushState) {
          window.history.pushState({}, '', href);
        }

        // Re-trigger any animation utility the theme might use
        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger();
        }
      })
      .catch(() => {
        // If fetch fails, fallback to full page navigation
        window.location.href = href;
      });
  }

  document.addEventListener('DOMContentLoaded', initCollectionFilters);
})(); 